/**
 * Token Storage Utility
 * Manages storage and retrieval of authentication tokens in localStorage
 */

/**
 * Store tokens in localStorage
 * @param {Object} tokens - Token object containing access_token, refresh_token, id_token, and expires_at
 */
export const tokenStorage = {
    setTokens: (tokens) => {
        localStorage.setItem('access_token', tokens.access_token);
        localStorage.setItem('refresh_token', tokens.refresh_token);
        localStorage.setItem('id_token', tokens.id_token);
        localStorage.setItem('expires_at', tokens.expires_at.toString());
    },

    getAccessToken: () => {
        return localStorage.getItem('access_token');
    },

    getRefreshToken: () => {
        return localStorage.getItem('refresh_token');
    },

    getIdToken: () => {
        return localStorage.getItem('id_token');
    },

    getExpiresAt: () => {
        const expiresAt = localStorage.getItem('expires_at');
        return expiresAt ? parseInt(expiresAt, 10) : null;
    },

    setUserProfile: (profile) => {
        localStorage.setItem('user_profile', JSON.stringify(profile));
        // Dispatch custom event to notify components that profile was stored
        window.dispatchEvent(new CustomEvent('userProfileStored'));
    },

    getUserProfile: () => {
        const profile = localStorage.getItem('user_profile');
        return profile ? JSON.parse(profile) : null;
    },

    clearTokens: () => {
        // Clear localStorage
        localStorage.clear();

        // Clear Keycloak authentication cookies
        const cookiesToClear = [
            'AUTH_SESSION_ID',
            'KC_RESTART',
            'KEYCLOAK_IDENTITY',
            'KEYCLOAK_SESSION'
        ];

        const clearCookie = (name) => {
            const hostname = window.location.hostname;
            const paths = ['/', '/auth'];
            const domains = [
                hostname,
                `.${hostname}`,
                window.location.host
            ];

            // Try clearing with different path and domain combinations
            paths.forEach(path => {
                domains.forEach(domain => {
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
                });
            });
        };

        cookiesToClear.forEach(clearCookie);
    },

    isTokenExpired: () => {
        const expiresAt = tokenStorage.getExpiresAt();
        if (!expiresAt) return true;
        const now = Math.floor(Date.now() / 1000);
        return now >= expiresAt;
    }
};
